export default class Clouds {
  constructor(areaSelector = ".js-cloudArea") {
    this.area = document.querySelector(areaSelector);
    this.clouds = [];
    this.cloudImages = [
      "kv__cloud1.svg",
      "kv__cloud2.svg",
      "kv__cloud3.svg",
      "kv__cloud4.svg",
      "kv__cloud5.svg",
      "kv__cloud6.svg"
    ];
    if (!this.area) return;

    this.area.style.position = "absolute";
    this.area.style.overflow = "hidden";

    // ★ レーン設定（縦方向の帯を作る）
    // 雲のだいたいの高さに合わせて調整。スマホはレーン細かめ。
    this.laneHeight = window.innerWidth <= 768 ? 90 : 120;
    this.laneCount  = Math.max(1, Math.floor(this.area.clientHeight / this.laneHeight));
    // 各レーンの最後尾情報を管理（x位置と速度）
    this.lanes = Array.from({ length: this.laneCount }, () => ({ lastCloud: null }));

    this.createInitialClouds();
    this.loop();
  }

  createInitialClouds() {
    const count = Math.floor(Math.random() * 4) + 3; // 3〜6個
    for (let i = 0; i < count; i++) {
      this.spawnCloud(true);
    }
    setInterval(() => {
      if (this.clouds.length < 6) this.spawnCloud();
    }, 2000);
  }

  // ★ 同一レーンでの最小横間隔（先行雲との距離）
  getLaneMinGap() {
    return window.innerWidth <= 768 ? 120 : 180; // 調整ポイント
  }

  spawnCloud(initial = false) {
    const img = document.createElement("img");
    img.src = `${themeVars.themeUrl}/assets/images/top/${this.cloudImages[Math.floor(Math.random() * this.cloudImages.length)]}`;
    img.className = "cloud-image";
    img.style.position = "absolute";
    img.style.pointerEvents = "none";
    img.style.opacity = 1;

    // ★ 幅：モバイルは小さめ（あなたの前回調整を踏襲）
    let width;
    if (window.innerWidth <= 768) {
      width = 80 + Math.random() * 60; // 80〜140
    } else {
      width = 100 + Math.random() * 100; // 100〜200
    }
    img.style.width = `${width}px`;
    // ※ 大きさのランダム性を scale で追加したい場合はここで足す

    // ★ レーンを選ぶ（他レーンと縦方向は絶対に被らない）
    const laneIndex = Math.floor(Math.random() * this.laneCount);
    const laneTop = laneIndex * this.laneHeight + (this.laneHeight - width * 0.5) * 0.2; // 少し余白
    img.style.top = `${Math.max(0, Math.min(this.area.clientHeight - this.laneHeight, laneTop))}px`;

    // ★ 左位置（初期配置）
    const left = initial ? Math.random() * this.area.clientWidth : -width;
    img.style.left = `${left}px`;

    // ★ 速度：同一レーンの先行雲より速くならないよう調整（追い越し防止）
    let speed = 0.2 + Math.random() * 0.3; // 基本レンジ
    const last = this.lanes[laneIndex].lastCloud;
    if (last) {
      // 先行雲との横間隔を確保
      const minGap = this.getLaneMinGap();
      const lastRight = last.left + last.width;
      const myRight   = left + width;

      // 初期位置が近すぎるなら、さらに左から出す（= 画面外の左）
      if (myRight > lastRight - minGap) {
        const shift = (myRight - (lastRight - minGap));
        const newLeft = left - shift - 10; // ちょい余裕
        img.style.left = `${newLeft}px`;
      }

      // 速度は先行雲以下に制限
      if (speed > last.speed) speed = last.speed * (0.9 + Math.random() * 0.1);
    }

    const cloud = { el: img, speed, left: parseFloat(img.style.left), width, laneIndex };
    this.area.appendChild(img);
    this.clouds.push(cloud);

    // ★ レーンの最後尾を更新
    this.lanes[laneIndex].lastCloud = cloud;
  }

  loop() {
    this.clouds.forEach((cloud, i) => {
      cloud.left += cloud.speed;
      cloud.el.style.left = `${cloud.left}px`;

      // 範囲外に出たら除去
      if (cloud.left > this.area.clientWidth + cloud.width) {
        cloud.el.remove();
        this.clouds.splice(i, 1);

        // レーン最後尾の再計算（簡易：そのレーンで最も右の雲を再設定）
        const laneClouds = this.clouds.filter(c => c.laneIndex === cloud.laneIndex);
        this.lanes[cloud.laneIndex].lastCloud =
          laneClouds.length ? laneClouds.reduce((a, b) => (a.left > b.left ? a : b)) : null;
      }
    });

    requestAnimationFrame(() => this.loop());
  }
}
